import React, { useState } from "react";
import { Redirect, Link } from 'react-router-dom';
import "../styles/questionStyles.css";
import "../styles/masterStyles.css";
import ModalWidget from "../components/ModalWidget";
import ModalForm from "../components/ModalForm";
import { 
    Container, Divider, Grid, Typography, TextField, 
    Table, TableBody, TableCell, TableContainer, 
    TableHead, TableRow, Paper, Popover, ListItem, 
    List, Fab, 
    TableFooter
} from "@material-ui/core"
import CloseIcon from '@material-ui/icons/Close';
import { isElectron, isMobileOnly, isAndroid, isIOS, isBrowser } from 'react-device-detect';
import { LoadingCard, CopyrightWidget } from "../components";
import { alertNotification, scrollTop, getThisYear, APPVERSION, remoteURL, OASIS_DATE, DATE, validCME } from "../common";

import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import { ScrollTopWidgetCard } from "./ScrollTopWidget";

export const CompleteCard = props => {
    console.log(props.results)
    const [value, setValue] = useState('');
    const [anchorEl, setAnchorEl] = useState(false);
    var conObj = {};
    /*
        gameMode={Number(props.gameMode)}
        deckID={Number(props.results.deckID)}
        yearvar={props.results.availableyears}
        mcid={props.user_details.mcid}
        myKey={props.user_details.key}
    */
    const handleSubmit = async (obj) => {
        let data = {
            mcid: obj.mcid,
            key: obj.key
        }

        if (typeof obj.yearvar !== 'undefined') {
            data.yearvar = obj.yearvar;
            data.gameMode = props.gameMode;
        } else if (typeof obj.deckID !== 'undefined') { 
            data.deckID = obj.deckID;
        }

        switch(obj.type) {
            case 'reset': {
                await props.resetDeck(data);

                alertNotification({
                    message: 'You have reset this test.',
                    title: 'SASP App Message',
                    buttonName: 'Done'
                });

                scrollTop('completeScreen-div', 0);

                return <Redirect to={{ pathname: '/home' }} />
            }

            case 'share': {
                data.shareWith = obj.shareWith;
                scrollTop('completeScreen-div', 0);

                alertNotification({
                    message: 'You have shared this deck with another user.',
                    title: 'SASP App Message',
                    buttonName: 'Done'
                });

                return props.shareDeck(data);
            }

            case 'email': {
                data.shareWith = obj.shareWith;
                data.results = props.results;
                data.gameMode = props.results.gameMode;

                document.getElementById('root').scrollTo({top: 0, behavior: "smooth"});
                scrollTop('completeScreen-div', 0);

                alertNotification({
                    message: 'You have emailed your results to another user.',
                    title: 'SASP App Message',
                    buttonName: 'Done'
                });

                return props.emailResults(data);
            }

            case 'note': {
                data.noteID = obj.noteID;
                data.state = obj.state;
                data.comment = obj.comment;
                return props.addNote(data);
            } 

            case 'complete': {
                data.qyear = obj.qyear;
                data.gamemode = obj.gamemode;
                // document.getElementById('root').scrollTo({top: 0, behavior: "smooth"});
                scrollTop('completeScreen-div', 0);

                alertNotification({
                    message: 'Results have been submitted. An email will be sent to you shortly to complete the Evaluation and Claim CME.',
                    title: 'SASP App Message',
                    buttonName: 'Done'
                });

                props.setComplete(0);

                return props.submitCME(data);
            }

            default: {
                // document.getElementById('root').scrollTo({top: 0, behavior: "smooth"});
                scrollTop('completeScreen-div', 0);
                return null;
            }
        }
    }

    const onConfirm = (index) => {
        index = Number(index);
        let _obj = {
            mcid: props.mcid,
            key: props.myKey,
            fkdeckid: conObj.deckuserid,
            active: 0,
            owner: conObj.owner
        }
        if (isAndroid) {
            switch (index) {
                case 1: {
                    props.removeShare(_obj);
                    return null;
                }
                default: {
                    return false;
                }
            }
        } else if (isIOS) {
            switch (index) {
                case 1: {
                    props.removeShare(_obj);
                    return null;
                }
                default: {
                    return false;
                }
            }
        } else {
            switch (index) {
                case 1: {
                    props.removeShare(_obj);
                    return null;
                }
                default: {
                    return false;
                }
            }
        }
    }

    const handleFABClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    
    const handleClose = () => {
        setAnchorEl(false);
    };
    
    let text = '';
    let header = '';

    if (props.gameMode < 3) { 
        let year = (props.question.QuestionYear ? props.question.QuestionYear : props.question.availableyears);
        text = "You have completed SASP " + props.testYear; 
        header = 'SASP ' + props.testYear;
    } else if (typeof props.deckID !== 'undefined') { 
        let thisDeck = props.deckList.find(item => item.deckID == props.deckID);

        if (typeof thisDeck !== 'undefined') {
            text = 'You have completed: ' + thisDeck.deckname; 
            header = thisDeck.deckname; 
        } else {
            text = ""; 
            header = 'SASP';
        }    
    } else { text = 'You have completed this Deck'; header = 'SASP' }

    const handleChange = (event) => {
        setValue(event.target.value);    
    };

    const handleBlur = async (event) => {
        
        let obj = {
            mcid: props.user_details.mcid,
            key: props.user_details.key,
            note: value,
            gameMode: Number(props.gameMode)
        }

        switch(Number(props.gameMode)) {
            case 1:
            case 2: {
                obj.yearvar = props.results.availableyears;
                break;
            }

            case 3:
            case 4: {
                obj.deckID = props.deckID;
                break;
            }
        }

        await props.addNote(obj);
    }

    let resObj = [{
        name: 'Deck Name',
        result: '0/0',
        percentage: 0,
        correct: 0,
        incorrect: 0,
        answered: 0,
        total: 0,
    }];
    let notes = [];

    let resultDetails = [];
    function compare(a, b) {
        if (a.qNumber > b.qNumber) { return 1 }
        else if (a.qNumber < b.qNumber) { return -1 }
        else { return 0 }
    }

    if (typeof props.results.questions !== 'undefined') {
        let temp = props.results.questions.filter(item => item.isActiveQuestion == '1');
        resultDetails = [...temp].sort(compare);
        const answeredObj = temp.filter(item => Number(item.totalResponses) > 0);
        const correctObj = temp.filter(item => Number(item.correctAnswers) > 0);
        const incorrectObj = temp.filter(item => Number(item.IncorrectAnswers) > 0);
        // notes = props.user_details.notes.notes.filter(item =>  props.results.questionlist.includes(item.questionID));
        
        let per = Math.trunc((props.results.getCorrectRecordCount / temp.length) * 100);
        // per = Math.trunc((props.results.correctAnswer / temp.length) * 100);
        
        resObj = [{
            name: header,
            result: correctObj.length + '/' + temp.length,
            percentage: per,
            correct: correctObj,
            incorrect: incorrectObj,
            answered: answeredObj,
            total: temp.length
        }];
    }

    const cleanText = (text) => {
        let r = '<p>' + text + '</p>';
        r = r.replace(/\n/g, '</p><p>');
        r = r.replace(/\r/g, '</p><p>');
        r = r.replace(/<\/p><p><\/p><p>/g, '</p><p>');
        return r;
    }

    const createMarkup = props => {
        let temp = props;
        if (!props.includes('<p>')) { temp = cleanText(temp); }
        return { __html: temp };
    };

    const fabCSS = {
        margin: "0 0 0 8px", 
        color: "#f1f3f5", 
        backgroundColor:"#00567a",
        position: 'fixed',
        top: 'calc(64px + env(safe-area-inset-top))',
        right: '16px'
    }

    const createFAB = (props) => {
        return (
            <>
                <Fab 
                    id={'Options-FAB'}
                    size="small"
                    style={fabCSS}
                    open={anchorEl}
                    onClick={handleFABClick}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                >
                    <MoreHorizIcon />
                </Fab>
                <Popover
                    id={'Options-Popover-DIV'}
                    open={anchorEl}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                >
                    <List dense={true}>
                        {props.deckID > 1
                            ? (
                                <ListItem className="width100">
                                    <ModalForm 
                                        type="share"
                                        sharable={true}
                                        color={"#00567a"}
                                        func={handleSubmit}
                                        title={"Share " + (props.gameMode > 2 ? 'Deck' : 'Test')}
                                        textstr={props.gameMode > 2 ? 'Deck' : 'Test'}
                                        gameMode={Number(props.gameMode)}
                                        deckID={Number(props.results.deckID)}
                                        yearvar={props.results.availableyears}
                                        mcid={props.user_details.mcid}
                                        myKey={props.user_details.key}
                                        accessList={props.accessList}
                                        cClasses={''}
                                        text={true}
                                    />
                                </ListItem>
                            ) : null
                        }

                        <ListItem className="width100">
                            <ModalForm 
                                type="reset"
                                // subtitle={'Restart'}
                                sharable={true}
                                color={"#00567a"}
                                func={handleSubmit}
                                title={"Reset " + (props.gameMode > 2 ? 'Deck' : 'Test')}
                                textstr={props.gameMode > 2 ? 'Deck' : 'Test'}
                                gameMode={Number(props.gameMode)}
                                deckID={Number(props.results.deckID)}
                                yearvar={props.results.availableyears}
                                mcid={props.user_details.mcid}
                                myKey={props.user_details.key}
                                accessList={props.accessList}
                                cClasses={''}
                                text={true}
                            />
                        </ListItem>

                        <ListItem className="width100">
                            <ModalForm 
                                type="email"
                                // subtitle={'Email Results'}
                                sharable={true}
                                color={"#00567a"}
                                func={handleSubmit}
                                title="Email Results"
                                textstr={props.gameMode > 2 ? 'Deck' : 'Test'}
                                gameMode={Number(props.gameMode)}
                                deckID={Number(props.results.deckID)}
                                yearvar={props.results.availableyears}
                                mcid={props.user_details.mcid}
                                myKey={props.user_details.key}
                                accessList={props.accessList}
                                // style={{margin: "0 !important;"}}
                                cClasses={''}
                                text={true}
                            />
                        </ListItem>

                        <ListItem className="width100">
                            {(props.results.completed == 0 && props.showComplete && validyear)
                                ? (
                                    <ModalForm 
                                        type="complete"
                                        // subtitle={'Complete'}
                                        sharable={true}
                                        color={"#00567a"}
                                        func={handleSubmit}
                                        title={"Submit for CME: SASP" + props.results.availableyears}
                                        textstr={props.gameMode > 2 ? 'Deck' : 'Test'}
                                        gameMode={Number(props.gameMode)}
                                        deckID={Number(props.results.deckID)}
                                        yearvar={props.results.availableyears}
                                        mcid={props.user_details.mcid}
                                        myKey={props.user_details.key}
                                        accessList={props.accessList}
                                        // yearvar={props.results.availableyears}
                                        id="complete-widget"
                                        cClasses={''}
                                        text={true}
                                    />
                                ) : null
                            }
                        </ListItem>
                    </List>
                </Popover>
            </>  
        
        )
    }

    let validyear = 0;
    let _d = new Date();
    let tempYear = _d.getFullYear() - 2;

    if (props.testYear >= tempYear) {
        validyear = 1;
    }
    
    let shareObj = [];

    if (props.deck !== null && typeof props.deck.shared !== 'undefined') {
        if (Array.isArray(props.deck.shared)) {
            shareObj = props.deck.shared
        }
    }

    try {
        if (!props.show) {
            return (
                <LoadingCard text="Loading..."/>
            );
        } else {
            const optClassText = (isMobileOnly || isElectron) ? 'width100 flex-row-between' : 'width100 flex-row-start';
            let showclaim = false;

            try {
                if (props.results.claimurl !== '') {
                    if (DATE > OASIS_DATE()) {
                        showclaim = true;
                    }
                }
            } catch (e) {}

            return (
                <Container
                    disableGutters={props.disableGutters || false}
                    fixed={props.fixed || false}
                    // style={props.container}
                    className="aua-overflow-old"
                    style={{
                        width: '100vw'
                    }}
                    id={`TestCompleteDiv`}
                >
                    <ScrollTopWidgetCard target={`CompletedTestDiv`} offset={54} />
                    <Grid item xs={12} className="">
                        <Typography 
                            className="DividerText anchor flex-row-between"
                        >
                                {header}
                                {createFAB(props)}  
                        </Typography>
                        <Divider className="margin-bottom-16 SASPDivider" />
                    </Grid>

                    {(!props.showComplete && validyear) 
                        ? (
                            <Grid 
                                item xs={12}
                                style={{
                                    padding: '0 8px',
                                    fontSize: '0.95rem',
                                    fontWeight: '400',
                                    border: '1px solid',
                                    borderRadius: '4px',
                                    background: '#e9e9e9'
                                }}
                            >
                                <p>In order to claim CME for this year you must answer at least 50% of the questions correctly.</p>

                                <p>
                                    <Link 
                                        to={{pathname:'/home'}}
                                        onClick={() => {
                                            let data = {
                                                mcid: props.mcid,
                                                key: props.myKey,
                                                type: 'reset'
                                            }

                                            if (typeof props.yearvar !== 'undefined'){
                                                data.yearvar = props.testYear.toString();
                                                data.shareWith = '';
                                                // data.gameMode = props.gameMode;
                                            } else if (typeof props.testYear !== 'undefined'){
                                                data.yearvar = props.testYear.toString();
                                                data.shareWith = '';
                                                // data.gameMode = props.gameMode;
                                            } else if (typeof props.deckID !== 'undefined') { 
                                                data.deckID = props.deckID;
                                            }

                                            handleSubmit(data)
                                        }}

                                        className="text-blue text-bold text-strong"
                                    >Click Here</Link> to restart the test and try again.
                                </p>
                            </Grid>
                        ) : null
                    }
                
                    <Grid item xs={12}>
                        <form noValidate autoComplete="off" className="hidden">
                            <TextField
                                id="deckcomment-multiline-flexible"
                                label="Add a comment to this deck"
                                multiline
                                rowsMax={10}
                                rows={4}
                                value={value}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                className="width100"
                            />
                        </form>
                    </Grid>

                    {showclaim && validCME(Number(props.results.yearvar))
                        ? (
                            <>
                                <Grid item xs={12} className="margin-bottom-16 margin-top-24">
                                    <div>
                                        <Link 
                                            className="sasp-review-btn-quiz"
                                            onClick={() => {
                                                console.log(props.results.claimurl)
                                                return remoteURL(props.results.claimurl);
                                            }}
                                        >
                                            View CME Now!
                                        </Link>
                                    </div>
                                </Grid>
                            </>
                        ) : null
                    }

                    {props.results.stats 
                        ? (
                            <>
                                <Grid item xs={12} className="margin-top-24">
                                    <Typography className="DividerText anchor flex-row-between">
                                        Summary
                                    </Typography>
                                    <Divider className="SASPDivider" />
                                </Grid>
                                <TableContainer class="margin-bottom-24"  component={Paper}>
                                    <Table style={{width: "100%"}} aria-label="custom pagination table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Type of Question</TableCell>
                                                <TableCell align="center" style={{width: "15vw", whiteSpace: "unset", wordBreak: "normal"}}>Questions&nbsp;(#)</TableCell>
                                                <TableCell align="center" style={{width: "15vw", whiteSpace: "unset", wordBreak: "normal"}}>Score&nbsp;(%)</TableCell>

                                                {APPVERSION > '2.11.6'
                                                    ? (
                                                        <TableCell align="center" style={{width: "15vw", whiteSpace: "unset", wordBreak: "normal"}}>All Users (%)</TableCell>
                                                    ) : null
                                                }
                                                
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {props.results.completed === 1
                                                ? (
                                                    <TableRow>
                                                        <TableCell component={'th'} align="left" colSpan={2}><strong>ABU Score</strong></TableCell>
                                                        <TableCell align="center">{props.results.score ? props.results.score : 0}%</TableCell>
                                                    </TableRow>
                                                ) : null
                                            }

                                            {props.results.stats.areas
                                                ? (
                                                    <>
                                                        {APPVERSION > '2.11.6'
                                                        ? (
                                                            <TableRow>
                                                                <TableCell component="th" scope="row" colspan={4}>
                                                                    <strong>Problem Area</strong>
                                                                </TableCell>
                                                            </TableRow>
                                                        ): (
                                                            <TableRow>
                                                                <TableCell component="th" scope="row" colspan={3}>
                                                                    <strong>Problem Area</strong>
                                                                </TableCell>
                                                            </TableRow>
                                                        )}

                                                        {props.results.stats.areas.map((row,index) => (
                                                            <TableRow key={`results-area-${index}`}>
                                                                <TableCell>{row.text}</TableCell>
                                                                <TableCell align="center">{row.questions}</TableCell>
                                                                <TableCell align="center">  
                                                                    {row.percentage.trim()}
                                                                </TableCell>
                                                                {APPVERSION > '2.11.6'
                                                                ? (
                                                                    <TableCell align="center">{row.overall.trim()}</TableCell>) 
                                                                    :null
                                                                }
                                                            </TableRow>
                                                        ))}
                                                    </>
                                                ) : null
                                            }

                                            {props.results.stats.patients
                                                ? (
                                                    <>
                                                        {APPVERSION > '2.11.6'
                                                        ? (
                                                            <TableRow>
                                                                <TableCell component="th" scope="row" colspan={4}>
                                                                    <strong>Problem Area</strong>
                                                                </TableCell>
                                                            </TableRow>
                                                        ): (
                                                            <TableRow>
                                                                <TableCell component="th" scope="row" colspan={3}>
                                                                    <strong>Problem Area</strong>
                                                                </TableCell>
                                                            </TableRow>
                                                        )}


                                                        {props.results.stats.patients.map((row,index) => (
                                                            <TableRow key={`results-patients-${index}`}>
                                                                <TableCell>{row.text}</TableCell>
                                                                <TableCell align="center">{row.questions}</TableCell>
                                                                <TableCell align="center">  
                                                                    {row.percentage.trim()}
                                                                </TableCell>
                                                                {APPVERSION > '2.11.6'
                                                                ? (
                                                                    <TableCell align="center">{row.overall.trim()}</TableCell>) 
                                                                    :null
                                                                }
                                                            </TableRow>
                                                        ))}
                                                    </>
                                                ) : null
                                            }
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </>
                        )
                        : null
                    }
               
                    <Grid item xs={12} className="hidden">
                        <div>Participant Profile (don't know format)</div>
                    </Grid>
                    <Divider className="margin-bottom-24 hidden" style={{margin: "8px 0 24px !important", width: "100%"}}  />

                    {props.deck !== null && typeof props.deck.shared !== 'undefined'
                        ? (
                            <>
                                <Grid item xs={12} className="margin-top-24">
                                    <Typography className="DividerText anchor flex-row-between">Shared With</Typography>
                                    <Divider className="SASPDivider" />
                                </Grid>
                                <>
                                    {shareObj.length
                                        ? (
                                            <TableContainer class="margin-bottom-24" component={Paper}>
                                                <Table style={{width: "100%"}} aria-label="simple table">
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell>User</TableCell>
                                                            <TableCell align="center">Active</TableCell>
                                                            {/* <TableCell align="center"></TableCell> */}
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {shareObj.map((row) => (
                                                            <TableRow key={row.displayname}>
                                                                <TableCell>
                                                                    <>
                                                                    {row.active
                                                                        ? (
                                                                            <Link 
                                                                                onClick={() => {
                                                                                    if (navigator.notification && row.active) {
                                                                                        conObj = row;
                                                                                        navigator.notification.confirm(
                                                                                            `Are you sure that you want to remove ${row.displayname}'s access from this deck?`,
                                                                                            onConfirm,
                                                                                            'SASP'
                                                                                        )
                                                                                    }
                                                                                }}
                                                                                className="text-blue"
                                                                            >
                                                                                {row.displayname}
                                                                            </Link> 
                                                                        )
                                                                        : (<>{row.displayname}</>)
                                                                    }
                                                                    
                                                                    </>      
                                                                </TableCell>
                                                                <TableCell align="center">
                                                                    <>
                                                                    {row.active
                                                                        ? (
                                                                            <Link 
                                                                                onClick={() => {
                                                                                    if (navigator.notification && row.active) {
                                                                                        conObj = row;
                                                                                        navigator.notification.confirm(
                                                                                            `Are you sure that you want to remove ${row.displayname}'s access from this deck?`,
                                                                                            onConfirm,
                                                                                            'SASP'
                                                                                        )
                                                                                    }
                                                                                }}
                                                                                className="text-blue"
                                                                            >
                                                                                {row.active ? 'Yes' : 'No'}
                                                                            </Link> 
                                                                        )
                                                                        : (<>{row.active ? 'Yes' : 'No'}</>)
                                                                    }
                                                                    
                                                                    </>
                                                                </TableCell>
                                                                {/* <TableCell align="center">&mdash;</TableCell> */}
                                                            </TableRow>
                                                        ))}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        )
                                        : (
                                            <p>You have not shared this deck with anyone.</p>
                                        )
                                    }   
                                </>
                            </>
                        ) : null
                    }

                    <Grid item xs={12} style={{marginTop: "24px"}}>
                        <Typography className="DividerText">Notes</Typography>
                        <Divider className="SASPDivider" />
                    </Grid>
                    <TableContainer class="margin-bottom-24"  component={Paper}>
                        <Table style={{width: "100%"}} aria-label="custom pagination table">
                            <TableBody style={{marginTop: "8px"}}>
                                {
                                    notes.length 
                                    ? (
                                        notes.map((row) => (
                                            <>
                                                <TableRow key={'noteDeatils-' + row.qNumber}>
                                                    <TableCell 
                                                        style={{
                                                            fontSize: "0.85rem",
                                                            border: "none",
                                                            padding: "16px 8px 0"
                                                        }} 
                                                        align="left" 
                                                        className="text-blue text-strong"
                                                    >
                                                        {row.qYear + 'Q' + row.qNumber}
                                                    </TableCell>

                                                    <TableCell
                                                        align="right"  
                                                        style={{
                                                            fontSize: "0.75rem",
                                                            width: "100px",
                                                            border: "none",
                                                            padding: "16px 8px 0"
                                                        }}
                                                    >
                                                        {row.dateStr}
                                                    </TableCell>
                                                    
                                                    <TableCell 
                                                        align="right" 
                                                        style={{
                                                            border: "none",
                                                            padding: "16px 0 0",
                                                            width: "35px"
                                                        }}
                                                    >
                                                        <CloseIcon 
                                                            className="text-orange"
                                                            style={{fontSize: "1.15rem"}}
                                                            onClick={() => handleSubmit({
                                                                noteID:row.noteID,
                                                                mcid: props.user_details.mcid,
                                                                key: props.user_details.key,
                                                                state: 0,
                                                                comment: row.comment,
                                                                type: 'note'
                                                            })}
                                                        />
                                                    </TableCell>
                                                </TableRow>

                                                <TableRow key={'note-' + row.qNumber}>
                                                    <TableCell
                                                        style={{fontSize: "0.75rem", padding: "0 8px"}} 
                                                        align="left" 
                                                        colSpan={3}
                                                    >
                                                        <div
                                                            dangerouslySetInnerHTML={createMarkup(row.comment)}
                                                        ></div>
                                                    </TableCell>
                                                </TableRow>
                                            </>
                                        ))
                                    )
                                    : (
                                        <TableRow key="no-notes">
                                            <TableCell 
                                                style={{fontSize: "0.95rem"}} 
                                                align="left"
                                                className="text-strong text-blue" 
                                            >
                                                No Comments
                                            </TableCell>
                                        </TableRow>
                                    )
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                
                    <CopyrightWidget 
                        begin={2012}
                        year={getThisYear()}
                        textAlign={'center'}
                        className="margin-top-48 padding-top-8 padding-bottom-8 padding-left-16 padding-right-16"
                    />
                </Container>
            );
        }
    } catch (e) {
        return (
            <LoadingCard text="Loading..."/>
        );
    }
};